module.exports = __webpack_public_path__ + "static/media/dops_logo_collapsed.89389783.png";